import { render, staticRenderFns } from "./AffiliateRegistrationSignature.vue?vue&type=template&id=a79de6a2"
import script from "./AffiliateRegistrationSignature.vue?vue&type=script&lang=ts"
export * from "./AffiliateRegistrationSignature.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports